// If any of these libs expect global jQuery:
import $ from 'jquery'
window.$ = $
window.jQuery = $

// Vendors (same order as CodeKit)
import './library/modernizr.js'
import '../components/slick-carousel/slick/slick.min.js'
import './library/photoswipe/photoswipe.js'
import './library/photoswipe/photoswipe-ui-default.js'
import './library/zoom.js'

// Your partials (same order as CodeKit)
import './partials/_base.js'
import './partials/_woocommerce.js'